export const getDiscoveryRedirectUrl = (isSignUp: boolean, redirect: string | null) => {
  const discoveryRedirectParams = new URLSearchParams();
  discoveryRedirectParams.set('signup', isSignUp.toString());
  if (redirect) {
    discoveryRedirectParams.set('redirect', redirect);
  }
  return `${location.origin}/sign-in?${discoveryRedirectParams.toString()}`;
};
